/** @format */

import { Inject, Injectable } from '@angular/core';

import { MyAccountErrorLogKeys } from '@shared/data-access/enums';
import { Environment } from '@shared/data-access/interfaces';
import { from, Observable, of } from 'rxjs';
import { catchError, map, pluck } from 'rxjs/operators';
import { WINDOW } from './window/window.service';
import { Logger } from './logger.service';
import { AnalyticsService } from './analytics.service';
@Injectable({
	providedIn: 'root'
})
export class ExclusiveContentService {
	constructor(
		private environment: Environment,
		@Inject(WINDOW) protected window: Window,
		private logger: Logger,
		private analyticsService: AnalyticsService
	) {}

	/**
	 * @description Calls party script and checks if the passed in party brand is active for this user.
	 * Returns an boolean observable that represents if user is connected to the specific party brand passed in.
	 * @param partyBrand
	 */
	public isUserConnectedToSpecificParty(partyBrand: string): Observable<boolean> {
		return from(
			this.window.party.getPartyAttributes(
				this.environment.partyAuthKeys.partnerKey,
				this.environment.partyAuthKeys.secretKey
			)
		).pipe(
			pluck('attributes'),
			map((value: []) =>
				value.some(
					(accountAttr: { id: string; value: string }) =>
						accountAttr.id === partyBrand && accountAttr.value === 'true'
				)
			),
			catchError((err) => {
				this.analyticsService.generateLogError(
					MyAccountErrorLogKeys.MYACCOUNT_PARTY_ATTRIBUTES_ERROR,
					'Failed to get Party attributes',
					err
				);
				this.logger.error('Error from calling party.js script', err);
				return of(false);
			})
		);
	}
}
